export const computeDropArea = (element) => {
    const clientRect = element.getBoundingClientRect();
    return {
        top: clientRect.top,
        left: clientRect.left,
        width: clientRect.width,
        height: clientRect.height
    };
};
export const dropAreasEqual = (dropAreaA, dropAreaB) => {
    return dropAreaA.top === dropAreaB.top
        && dropAreaA.left === dropAreaB.left
        && dropAreaA.width === dropAreaB.width
        && dropAreaA.height === dropAreaB.height;
};
export const pointInDropArea = (dropArea, point) => {
    return dropArea.top <= point.y
        && point.y <= dropArea.top + dropArea.height
        && dropArea.left <= point.x
        && point.x <= dropArea.left + dropArea.width;
};
//# sourceMappingURL=drop-model.js.map